export default __webpack_public_path__ + "cccfe9951f0c5a0f4ba689d41b093eb8.jpg";